import { useState, useEffect } from 'react';

import { fetchCategories } from "../api/api";

import SearchBar from "../components/SearchBar";
import CategoryCard from "../components/CategoryCard";
import StickyNavbar from "../components/StickyNavbar";

import CSpinner from '../components/CSpinner';


const Categories = () => {
  const [categories, setCategories] = useState([]);

  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetchCategories();
        setCategories(Array.isArray(res.categories) ? res.categories : []);

      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6" >
      <StickyNavbar />

      <div className="w-full max-w-4xl pt-20">

        <div className="flex justify-center items-center">
          {loading && <CSpinner />}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6" >
          {categories.map((category) => (
            <CategoryCard key={category._id} category={category} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;
